import { render } from "./Train.vue?vue&type=template&id=3f537012&scoped=true"
import script from "./Train.vue?vue&type=script&lang=js"
export * from "./Train.vue?vue&type=script&lang=js"

import "./Train.vue?vue&type=style&index=0&id=3f537012&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f537012"]])

export default __exports__